<template>
    <div class="p-3">
        <h3>RL 3.1 Indikator Pelayanan</h3>
        <hr>

        <!-- Tabs Navigation -->
        <ul class="nav nav-tabs mb-3" role="tablist">
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    :class="{ active: activeTab === 'detail' }"
                    @click="activeTab = 'detail'"
                    type="button"
                >
                    Detail
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    :class="{ active: activeTab === 'rekap' }"
                    @click="activeTab = 'rekap'"
                    type="button"
                >
                    Rekap
                </button>
            </li>
        </ul>

        <!-- Tab Content -->
        <div class="tab-content">
            <!-- Detail Tab -->
            <div v-show="activeTab === 'detail'">
                <DataTable table-id="table-indikator-detail" title="Indikator Pelayanan - Detail"
                    :filter-configs="filterConfigs"
                    :table-options="tableOptionsDetail" :show-filter="true" />
            </div>

            <!-- Rekap Tab -->
            <div v-show="activeTab === 'rekap'">
                <DataTable table-id="table-indikator-rekap" title="Indikator Pelayanan - Rekap"
                    :filter-configs="filterConfigs"
                    :table-options="tableOptionsRekap" :show-filter="true" />
            </div>
        </div>
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            activeTab: 'detail',
            filterConfigs: [
                {
                    id: 'start_date',
                    label: 'Tanggal Awal',
                    field: 'start_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
                {
                    id: 'end_date',
                    label: 'Tanggal Akhir',
                    field: 'end_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
            ],
            tableOptionsDetail: {
                baseUrl: '/api/rekapitulasi-pelayanan/indikator-pelayanan',
                layout: "fitColumns",
                columns: [
                    {
                        title: "Jenis Pelayanan",
                        field: "NmBangsal",
                    },
                    {
                        title: "BOR",
                        field: "BOR",
                        hozAlign: "center",
                        formatter: function (cell, formatterParams, onRendered) {
                            return cell.getValue() + " %";
                        },
                    },
                    {
                        title: "ALOS ",
                        field: "LOS",
                        hozAlign: "center",
                        formatter: function (cell, formatterParams, onRendered) {
                            return cell.getValue() + " Hari";
                        },
                    },
                    {
                        title: "BTO",
                        field: "BTO",
                        hozAlign: "center",
                        formatter: function (cell, formatterParams, onRendered) {
                            return cell.getValue() + " Kali";
                        },
                    },
                    {
                        title: "TOI ",
                        field: "TOI",
                        hozAlign: "center",
                        formatter: function (cell, formatterParams, onRendered) {
                            return cell.getValue() + " Hari";
                        },
                    },
                    {
                        title: "NDR ",
                        field: "NTR",
                        hozAlign: "center",
                    },
                    {
                        title: "GDR ",
                        field: "GDR",
                        hozAlign: "center",
                    }
                ],
                ajaxResponse: (url, params, response) => response
            },
            tableOptionsRekap: {
                baseUrl: '/api/rekapitulasi-pelayanan/indikator-pelayanan-grouped',
                layout: "fitColumns",
                columns: [
                    {
                        title: "Jenis Pelayanan",
                        field: "NmBangsal",
                    },
                    {
                        title: "BOR",
                        field: "BOR",
                        hozAlign: "center",
                        formatter: function (cell, formatterParams, onRendered) {
                            return cell.getValue() + " %";
                        },
                    },
                    {
                        title: "ALOS ",
                        field: "LOS",
                        hozAlign: "center",
                        formatter: function (cell, formatterParams, onRendered) {
                            return cell.getValue() + " Hari";
                        },
                    },
                    {
                        title: "BTO",
                        field: "BTO",
                        hozAlign: "center",
                        formatter: function (cell, formatterParams, onRendered) {
                            return cell.getValue() + " Kali";
                        },
                    },
                    {
                        title: "TOI ",
                        field: "TOI",
                        hozAlign: "center",
                        formatter: function (cell, formatterParams, onRendered) {
                            return cell.getValue() + " Hari";
                        },
                    },
                    {
                        title: "NDR ",
                        field: "NTR",
                        hozAlign: "center",
                    },
                    {
                        title: "GDR ",
                        field: "GDR",
                        hozAlign: "center",
                    }
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
